import React, { useState, useContext } from 'react'
import { navigate } from 'gatsby'
import styled from 'styled-components'
import Form from './Form'
import { appContext } from '../shared/contexts'
import { useApiLoad } from '../shared/hooks'
import {
  PageTitle,
  PageContent,
  PageLoading,
  directFormStyles,
} from '../shared/elements'
import { putRequest } from '../../services/api'
import * as paths from '../../utils/paths'

const Container = styled.div`
  ${directFormStyles}
`

export default function EditShortlink(props) {
  const { publisherUuid, contractUuid, shortlinkUuid } = props

  const { showMessage } = useContext(appContext)

  const [shortlink, setShortlink] = useState(null)

  const onSubmit = async (values) => {
    const result = await putRequest(`/advertiser/shortlinks/${shortlinkUuid}`, {
      shortlink: {
        ...values,
      },
    })

    if (result?.data?.success) {
      navigate(
        paths.publisherContractShortlinksPath(publisherUuid, contractUuid)
      )
    } else {
      console.error(result)
      showMessage(result?.message)
    }
  }

  useApiLoad(
    `/advertiser/shortlinks/${publisherUuid}/${contractUuid}/${shortlinkUuid}`,
    shortlink === null,
    (response) => {
      setShortlink(response?.data?.shortlink)
    }
  )

  const loading = shortlink === null
  if (loading) {
    return (
      <PageLoading
        title="Edit smart link"
        backPath={paths.publisherContractShortlinksPath(
          publisherUuid,
          contractUuid
        )}
      />
    )
  }

  return (
    <Container>
      <PageTitle
        title="Edit smart link"
        backPath={paths.publisherContractShortlinksPath(
          publisherUuid,
          contractUuid
        )}
      />

      <PageContent>
        <div className="panel px-4 py-5 mt-20">
          <Form initialValue={shortlink} onSubmit={onSubmit} />
        </div>
      </PageContent>
    </Container>
  )
}
